import { render, staticRenderFns } from "./ComposeEmailPane.vue?vue&type=template&id=1fe40818"
import script from "./ComposeEmailPane.vue?vue&type=script&lang=js"
export * from "./ComposeEmailPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports